module.exports = __webpack_public_path__ + "img/kusa02.e6ebc7a8.png";